import React, { useEffect, useLayoutEffect, useState } from "react";
import Logo, { LogoType } from "../../Components/Logo/Logo";
import arrowLeft from "../../assets/icons/arrow-left.svg";
import "./PrivacyPolicyPage.css";
import { useLocation, useNavigate } from "react-router-dom";
import { BACKEND_URL } from "../../utils/env-variables/env-variables";

interface PrivacyPolicyProps {
  countryCode: string;
  languageCode: string;
}

interface PrivacyPolicyResponse {
  header: string;
  content: string;
}

const PrivacyPolicyPage: React.FC<PrivacyPolicyProps> = ({
  countryCode,
  languageCode,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [policyContent, setPolicyContent] = useState<string>("");

  const onBackButtonClick = () => {
    navigate(window.location.pathname.replace("/privacy-policy", ""));
  };

  useLayoutEffect(() => {
    document.documentElement.scrollTo({ top: 0, left: 0 });
  }, [location.pathname]);

  useEffect(() => {
    const fetchPrivacyPolicy = async () => {
      try {
        const response = await fetch(
          `${BACKEND_URL}/Consent/privacyPolicyLandingPage/${countryCode}/${languageCode}`,
        );
        const data: PrivacyPolicyResponse = await response.json();
        document.title = data.header;
        setPolicyContent(data.content);
      } catch (error) {
        setPolicyContent("Error fetching privacy policy");
      }
    };

    fetchPrivacyPolicy();
  }, [countryCode, languageCode]);

  return (
    <div className="flex min-h-screen pl-4 pr-4 pb-4 justify-center">
      <div className="large-layout w-full text-left">
        <div className="sticky top-0 z-10 pt-4">
          <button
            className="back-button-privacy-policy mb-5"
            onClick={onBackButtonClick}
          >
            <div className="flex flex-row gap-2">
              <img src={arrowLeft} alt="Back" />
              <p className="button-text">Back</p>
            </div>
          </button>
        </div>
        <Logo type={LogoType.Horizontal} />
        <div
          className="privacy-policy"
          dangerouslySetInnerHTML={{ __html: policyContent }}
        />
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
